module.exports = __webpack_public_path__ + "40fa2b12cf5b244080ce2b2399857996.pdf";